import api from "@/services/api/axios-client";
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import {
  DefaultApiCommentsControllerCreateRequest,
  DefaultApiCommentsControllerUpdateCommentAsSeenRequest,
  GetCommentDto,
} from "generated";
import { useCurrentUploadId } from "./uploads";

export const useCurrentUploadCommentsQuery = (): UseQueryResult<
  GetCommentDto[],
  Error
> => {
  const uploadId = useCurrentUploadId();
  return useQuery({
    queryKey: ["comments", uploadId],
    queryFn: async () => {
      return api
        .commentsControllerGetCommentsByUploadId({ uploadId })
        .then((response) => response.data);
    },
  });
};

export const usePostCurrentUploadCommentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (comment: DefaultApiCommentsControllerCreateRequest) => {
      return api.commentsControllerCreate(comment);
    },
    onSuccess: (newComment) => {
      queryClient.setQueryData(
        ["comments", newComment.data.uploadId],
        (cachedData: GetCommentDto[] = []) => {
          return [...cachedData, newComment.data];
        },
      );
    },
  });
};

export const useMarkCommentsAsSeenMutation = () => {
  return useMutation({
    mutationFn: async (
      commAsSeen: DefaultApiCommentsControllerUpdateCommentAsSeenRequest,
    ) => await api.commentsControllerUpdateCommentAsSeen(commAsSeen),
  });
};
